/** Small helpers for the simulator screens. */

const nf = new Intl.NumberFormat('es-ES');
export const num = (n: number): string => nf.format(n);

export const euros = (n: number): string =>
  new Intl.NumberFormat('es-ES', {
    style: 'currency',
    currency: 'EUR',
    maximumFractionDigits: 0,
  }).format(n);

export const plural = (n: number, one: string, many: string): string =>
  `${num(n)} ${n === 1 ? one : many}`;

/** "+3" / "−2" */
export const signed = (n: number): string => (n > 0 ? `+${num(n)}` : `−${num(Math.abs(n))}`);

/** "3 h 12 min", "12 min", "40 s" until a moment. */
export function countdown(ms: number): string {
  if (ms <= 0) return 'ya';
  const total = Math.ceil(ms / 1000);
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  if (h > 0) return `${h} h ${m} min`;
  if (m > 0) return `${m} min`;
  return `${total} s`;
}

/** Whole days until a moment (at least 0). */
export const daysUntil = (iso: string, now = Date.now()): number =>
  Math.max(0, Math.ceil((new Date(iso).getTime() - now) / 86_400_000));

/** How a character feels about the player, −10 … +10. */
export function relationLabel(r: number): string {
  if (r <= -6) return 'Enemistad';
  if (r <= -2) return 'Tirantez';
  if (r < 2) return 'Trato cordial';
  if (r < 6) return 'Aprecio';
  return 'Uña y carne';
}

/** The brotherhood as the texts name it: "la Paciencia" or the full name. */
export const brotherhoodName = (b: { name: string; popular_name: string | null }): string =>
  b.popular_name ?? b.name;

export const upperFirst = (s: string): string => (s ? `${s[0]!.toUpperCase()}${s.slice(1)}` : s);
